import React, { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';

import VariationInfo from '../../VariationInfo';

export default function useWarning() {
  const intl = useIntl();
  const deliveryType = useSelector(state => state.order.checkout.deliveryType);
  const pickupBonuses = useSelector(state => state.stock.unconditionalList.data.rewards?.[0]);
  const unit = useSelector(state => state.city.userCity.currency?.unit);
  const stockCode = useSelector(state => state.stock.data.code);

  let label = null;

  if (deliveryType === 'pickup' && pickupBonuses && !stockCode) {
    const index = pickupBonuses.reward === 'order_discount' ? 1 : 2;
    const good = pickupBonuses.goods?.[0]?.name;
    const variation = pickupBonuses.goods?.[0]?.variations?.[0];
    const variationDescription = <VariationInfo {...variation} style={{ display: 'inline' }} />;
    const newUnit = pickupBonuses.type === 'percent' ? '%' : ` ${unit}`;
    const discount = `${pickupBonuses.reward_value}${newUnit}`;

    label = intl.formatMessage(
      { id: `checkout.pickup.info${index}` },
      { discount, good, variation: variationDescription },
    );
  }

  return { label };
}
